export const HIDE_LOADER = 'CLOSE_LOADER';
export const SHOW_LOADER = 'SHOW_LOADER';

export const hideLoader = () => ({
    type: HIDE_LOADER,
});

export const showLoader = (text) => ({
    type: SHOW_LOADER,
    payload: {
        text,
    },
});
